import script from "./summaryA.vue?vue&type=script&setup=true&lang=js"
export * from "./summaryA.vue?vue&type=script&setup=true&lang=js"

import "./summaryA.vue?vue&type=style&index=0&id=2c4025dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4025dd"]])

export default __exports__